/**
 * Three.js Background Types
 *
 * Type definitions for ThreeBackground component
 */

import * as THREE from 'three';

/**
 * Props for ThreeBackground component
 */
export interface ThreeBackgroundProps {
  canvasId?: string;
}

/**
 * Animation context passed to update functions
 */
export interface AnimationContext {
  time: number;
  mouse: {
    x: number;
    y: number;
    targetX: number;
    targetY: number;
    velocity: number;
  };
  beat: {
    intensity: number;
    time: number;
  };
  phi: number;
}

/**
 * Effect layer interface for BGM sync
 */
export interface EffectLayer {
  onKickDetected: (intensity: number, mood: string, musicAnalysis: unknown, layer?: string) => void;
  onSnareDetected: (intensity: number, mood: string, musicAnalysis: unknown, layer?: string) => void;
  onHihatDetected: (intensity: number, mood: string, musicAnalysis: unknown, layer?: string) => void;
  activate: () => void;
  deactivate: () => void;
  isActive: boolean;
}

/**
 * System object with update callback
 */
export interface SystemObject extends THREE.Object3D {
  userData: {
    update?: (ctx: AnimationContext) => void;
  };
}

/**
 * Visual effect creator function type
 */
export type EffectCreator = (
  scene: THREE.Scene,
  systemsRef: React.MutableRefObject<SystemObject[]>
) => void;

/**
 * Golden ratio and Fibonacci constants
 */
export const PHI = 1.618033988749895;
export const FIBONACCI = [1, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144];
